import { PayrollStatuses } from './payroll';

export enum TaskPriorities {
  Low = 1,
  Medium = 2,
  High = 3,
  Urgent = 4
}

export enum TaskStatuses {
  Open = 2,
  Pending = 3,
  Resolved = 4,
  Closed = 5,
  WaitingOnClient = 6,
  Reassigned = 8
}

export class Task {
  Id: number;
  CalendarId: number;
  ClientCode: string;
  ClientName: string;
  ClientLegalName: string;
  ClientDba: string;
  Description: string;
  DueDate: Date;
  SubTaskCount: number;
  // NOTE: set at runtime from last view user map
  IsRead: boolean = false;
  Name: string;
  Source: number;
  Status: TaskStatuses;
  Subject: string;
  Priority: TaskPriorities;
  TaskNote: string;
  TaskNoteLastEditedUserName: string;
  TaskNoteLastEditedOn: Date;
  Type: string;
  CreatedOn: Date;
  LastEditedOn: Date;

  // only available for Payroll Tasks
  PayDate: Date;
  PayFrequency: string;
  PayrollInputMethod: string;
  PayrollStatus: PayrollStatuses;
  PayrollType: string;

  // contacts
  ContactName: string;
  ContactPhone: string;
  ContactEmail: string;

  CreatorAgileId: string;
  AssigneeAgileId: string;

  // some tasks, like payroll, have action links attached to them
  ActionLink: string;
  ActionLinkText: string;
}

export enum TaskListMode {
  Payroll = 'Payroll',
  Other = 'Other'
}

export enum TaskViewMode {
  MyTasks,
  MyOfficeTasks,
  CSRTasks,
  OfficeTasks
}

export class SubTask {
  SubTaskId: number;
  FreshdeskTicketId: number;
  IsComplete: boolean;
  Description: string;
  Position: number;
  TaskGroupId: number;
  CompletedBy: string;
  CompletedOn: Date;
}

export class SubTaskCompletion {
  TaskId: number;
  SubTaskId: number;
  IsComplete: boolean;

  constructor(taskId: number, subTaskId: number, complete: boolean) {
    this.TaskId = taskId;
    this.SubTaskId = subTaskId;
    this.IsComplete = complete;
  }
}

export class CompanyContact {
  SequenceNumber: number;
  Email: string;
  Name: string;
  Phone: string;
  LocationId: number;
  ContactType: string;
  IsPrimary: boolean;
}

export class TaskSearchConfig {
  PageNumber: number = 1;
  PageSize: number = 25;
  TotalPages: number;
  SortKey: string;
  SortDirection: string;
  ClientName: string;
  ClientDba: string;
  ClientLegalName: string;
  ClientId: string;
  TaskTypes: string[] = [];
  Priority: string;
  Assignees: string[] = [];
  DueDate: Date;
  DueDateLike: string;
  Statuses: number[] = [];
}

export class PayrollTaskSearchConfig extends TaskSearchConfig {
  PayDate: string;
  PayrollStatuses: string[] = [];
  PayrollFrequency: string;
  ContactName: string;
  ContactEmail: string;
  ContactPhone: string;
  ReceivedBy: string[]; // a.k.a Payroll Input Method
}
